import Repository from '../axios'

const resource = "/admin/formulations/production_codes";

export default {
  getListOfProductionCodes() {
    return Repository.get(`${resource}`)
  },
  getFormulationProductionCodesDropdown(formulation_type) {
    return Repository.get(`/admin/formulations/production-code-list?filter[formulation_type]=${formulation_type}`)
  },
  getProductionCode(id) {
    return Repository.get(`${resource}/${id}`)
  },
  createProductionCode(payload) {
    return Repository.post(`${resource}`, payload)
  },
  updateProductionCode(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  },
};
